import type { FC } from 'react';
import { memo } from 'react';

import type { CurrencyFormatterOptions } from '../../formatters/CurrencyFormatter';
import { CurrencyFormatter } from '../../formatters/CurrencyFormatter';

export interface CurrencyProps extends CurrencyFormatterOptions {
  /** The value to be formatted */
  value: number;
  /** The locale to be used for formatting */
  locale: string;
}

const CurrencyComponent: FC<CurrencyProps> = ({ value, locale, ...rest }) =>
  CurrencyFormatter.format(value, locale, rest);

export const Currency = memo(CurrencyComponent);
